var isRotationDirectionNormal = true;
